import { PHONENUMBER_FORMAT } from '../../../../constants';
import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: ' Title',
    field: 'contactsTitle',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Contact Name',
    field: 'contactsFullName',
    filter: 'text',
    searchable: true,
  },

  {
    title: 'Description',
    field: 'contactsDescription',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Work Email',
    field: 'contactsWorkEmail',
    filter: 'text',
    searchable: true,
    width: '320',
  },
  {
    title: 'Other Email',
    field: 'contactsSecondaryEmail',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Phone',
    field: 'contactsOfficePhone',
    filter: 'text',
    searchable: true,
    formatPattern: PHONENUMBER_FORMAT,
  },
  {
    title: 'Cell Phone',
    field: 'contactsCellPhone',
    filter: 'text',
    searchable: true,
    formatPattern: PHONENUMBER_FORMAT,
  },
  {
    title: ' Role',
    field: 'contactsRoleName',
    filter: 'text',
    searchable: true,
  },
];
